export const environment = {
  apiUrl: 'https://staging.api2.listofin.com/auto-service',
  zipCodeApiUrl: 'https://staging.api2.listofin.com/store-service',
  production: true,
  expandedRaterUrl: 'https://pos.listofin.com',
  cookieDomain: 'listofin.com',
  siteKey: '6LdRkekiAAAAADswDCzMr3YZOReFs5p-uhXZgnB3',
  apiUrlV2: 'https://loans-staging.herokuapp.com',
};
